<template>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1955_204)">
      <path d="M10.5 0.748535H1.5C1.08579 0.748535 0.75 1.08432 0.75 1.49854V10.4985C0.75 10.9127 1.08579 11.2485 1.5 11.2485H10.5C10.9142 11.2485 11.25 10.9127 11.25 10.4985V1.49854C11.25 1.08432 10.9142 0.748535 10.5 0.748535Z" stroke="#8090A2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M0.75 3.74854H11.25" stroke="#8090A2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_1955_204">
        <rect width="12" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  name: 'TableLayoutIcon'
};
</script>
